<template>
    <!-- 
    <v-dialog
        v-model="loadingStatus"
        persistent
        width="200"
        overlay-color="rgba(24, 61, 101, 0.5)">
        <v-card
            tile
            flat
            class="pa-4 text-center">
            <v-progress-circular
                indeterminate
                color="red"
            >
            </v-progress-circular>
            <p class="mt-4">
                <b>작업을 진행중입니다</b><br/>
                <span class="caption">자동으로 창이 닫힙니다</span>
            </p>
        </v-card>
    </v-dialog> 
    -->
    <v-overlay
        :z-index="100"
        :value="loadingStatus"
        color="#183d65"
        opacity="0.37">
        <v-card
            flat
            color="transparent"
            class="elevation-0">
            <v-responsive>
                <img width="100" src="@/assets/images/loading-nobg.gif" alt="loading data">
            </v-responsive>
        </v-card>
    </v-overlay>
</template>

<script>
export default {
    name: 'ProgressDialog',
    computed: {
        loadingStatus() {
            return this.$store.state.loadingStatus
        }
    },
}
</script>


// WEBPACK FOOTER //
// src/components/commons/ProgressDialog.vue